import { render, staticRenderFns } from "./AgencyToOwnerPending.vue?vue&type=template&id=36a4f692&"
import script from "./AgencyToOwnerPending.vue?vue&type=script&lang=js&"
export * from "./AgencyToOwnerPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports